import { Delegate } from "dom-delegate";
import { init, trackEvent } from "./helpers";

let instances = [];

class ChargerSelector {
    constructor(element) {
        init(window.gtmId);

        this.form = element;
        this.type = this.formData().get("type");
        this.currency = this.formData().get("currency");
        this.chargerNames = JSON.parse(this.form.dataset.chargerNames || "{}");

        this.power = undefined;
        this.price = undefined;

        this.bindEvents();
    }

    formData() {
        return new FormData(this.form);
    }

    bindEvents() {
        this.listener = new Delegate(this.form);

        this.listener.on("change", (event) => {
            event.preventDefault();

            this.formChangeHandler(event);
        });

        // Prevent the `?type=` query param to be used upon submission
        this.listener.on("submit", () => {
            const eventProperties = this.generateTrackingEventProperties();

            this.form
                .querySelectorAll("input:not([name='sku'])")
                .forEach((element) => element.setAttribute("disabled", true));

            trackEvent("add_to_cart", eventProperties);
        });
    }

    unbindEvents() {
        this.listener.destroy();
    }

    formChangeHandler(event) {
        if (this.typeHasChanged()) {
            this.type = this.formData().get("type");
            this.power = undefined;
            const availablePrices = [];
            this.form.querySelectorAll("[data-charger-type]").forEach((element) => {
                if (element.dataset.chargerType === this.type) {
                    element.classList.remove("tw-hidden");
                    element.classList.add("tw-block");
                } else {
                    element.classList.remove("tw-block");
                    element.classList.add("tw-hidden");
                }
            });
            this.form.querySelectorAll("[data-power-option]").forEach((element) => {
                const power = element.dataset.powerOption.toLowerCase();
                const sku = event.target.dataset[`sku-${power}`];
                const price = {
                    value: parseFloat(event.target.dataset[`price-${power}`]),
                    formatted: event.target.dataset[`formattedPrice-${power}`],
                };

                // Update power options prices
                element.querySelector("[data-field='price']").dataset.value = price.value.toString();
                element.querySelector("[data-field='price']").textContent = price.formatted;
                availablePrices.push(price);
                // Update selected SKU field value
                element.querySelector("input[name='sku']").value = sku;
                // Clear current SKU selection
                element.querySelector("input[name='sku']").checked = false;
            });

            // "from" price is the cheapest available price
            this.price = availablePrices.reduce((a, b) => (a.value < b.value ? a : b));
        } else if (this.powerIsSelected()) {
            const powerOptionElement = event.target.closest("[data-power-option]");
            const powerOptionPriceElement = powerOptionElement.querySelector("[data-field='price']");

            // selected power rating
            this.power = powerOptionElement.dataset.powerOption;
            // "definite" price
            this.price = {
                value: parseFloat(powerOptionPriceElement.dataset.value),
                formatted: powerOptionPriceElement.textContent.trim(),
            };
        }

        this.updateChargeEstimates();
        this.toggleBasketPrefix();
        this.updateBasketPrice();
        this.toggleSubmitButton();
    }

    typeHasChanged() {
        return this.type !== this.formData().get("type");
    }

    powerIsSelected() {
        return this.formData().has("sku");
    }

    isValid() {
        return this.type && this.powerIsSelected();
    }

    toggleBasketPrefix() {
        this.form.querySelector("[data-field='basket-prefix']").hidden = this.isValid();
    }

    updateBasketPrice() {
        if (!this.price) {
            return;
        }

        this.form.querySelector("[data-field='basket-price']").textContent = this.price.formatted;
    }

    updateChargeEstimates() {
        this.form.querySelectorAll("[data-charge-estimate-power]").forEach((element) => {
            element.hidden = element.dataset.chargeEstimatePower.toLowerCase() !== this.power;
        });

        this.form.querySelectorAll("[data-charge-estimate-any]").forEach((element) => {
            element.hidden = this.power === undefined;
        });
    }

    toggleSubmitButton() {
        const button = this.form.querySelector("button[type='submit']");

        this.isValid() ? button.removeAttribute("disabled") : button.setAttribute("disabled", true);
    }

    generateTrackingEventProperties() {
        const sku = this.formData().get("sku");

        return {
            currency: this.currency,
            value: this.price.value,
            items: [
                {
                    item_id: sku,
                    item_name: this.chargerNames[sku],
                    price: this.price.value,
                    quantity: 1,
                    affiliation: "PDP",
                    item_brand: "Pod Point",
                    connection_type: "Type 2 socket",
                    power_rating: this.power,
                    item_type: "Charger",
                    item_variant: "Physical",
                },
            ],
        };
    }
}

export default {
    init: function (element) {
        instances.push(new ChargerSelector(element));
    },

    destroy: function () {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
